import { render } from "./Card.vue?vue&type=template&id=3424e152&scoped=true&lang=html"
const script = {}

import "./Card.vue?vue&type=style&index=0&id=3424e152&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3424e152"]])

export default __exports__